import React from "react";
import { memo } from "react";


const Home = memo(() => {
    return  <div className="welcome-message">
                <h1>Welcome!</h1>
                <p>We are glad to have you here.</p>
            </div>;
});

export default Home;